import React from 'react';

/** Same path as Android {@code illus_main_mock_route.xml} / {@code MainHomeCardAnimations}. */
const ROUTE_PATH =
  'M28,68 C70,20 110,80 150,44 C190,12 230,36 292,24';

const ItineraryRoutePreview: React.FC = () => (
  <div className="login-route-panel" aria-hidden="true">
    <svg
      className="login-route-illus"
      viewBox="0 0 320 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M0,32 H320 M0,64 H320 M80,0 V96 M200,0 V96"
        stroke="currentColor"
        strokeOpacity="0.16"
        strokeWidth="1"
      />
      <path
        d={ROUTE_PATH}
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={ROUTE_PATH}
        stroke="#FFFFFF"
        strokeOpacity="0.35"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="28" cy="68" r="6" fill="#34A853" />
      <circle cx="28" cy="68" r="2.5" fill="#FFFFFF" />
      <circle cx="150" cy="44" r="5" fill="#FB923C" />
      <circle cx="292" cy="24" r="6" fill="#EA4335" />
      <circle cx="235" cy="28" r="5" fill="#EA580C" />
      <g className="login-route-illus__dot-wrap">
        <circle
          r="6"
          fill="#1A2030"
          stroke="#FFFFFF"
          strokeWidth="1.5"
        >
          <animateMotion
            dur="2.8s"
            repeatCount="indefinite"
            path={ROUTE_PATH}
          />
        </circle>
      </g>
    </svg>
  </div>
);

export default ItineraryRoutePreview;
